export const blogPosts = [
  {
    slug: 'ai-receptionist-for-small-business-guide',
    title: 'AI Receptionist for Small Business: The Complete 2026 Guide',
    description: 'What an AI receptionist is, what it costs in 2026, what it can and can\'t do, and how to set one up — a practical, hype-free guide for small business owners.',
    date: '2026-06-12',
    author: 'UBOTIKA Team',
    readTime: '10 min read',
    tags: ['AI Receptionist', 'Small Business', 'Guide', '2026'],
    image: 'https://storage.googleapis.com/lupatest/Ubotika-nav/ai-agents.jpg',
  },
  {
    slug: 'how-many-calls-do-small-businesses-miss',
    title: 'How Many Calls Do Small Businesses Miss? The Real Numbers',
    description: 'Small businesses miss roughly 25–40% of inbound calls, and 60–80% of voicemail callers never leave a message. The real numbers, and what they cost you.',
    date: '2026-06-12',
    author: 'UBOTIKA Team',
    readTime: '8 min read',
    tags: ['Missed Calls', 'Small Business', 'Statistics', 'Lead Capture'],
    image: 'https://storage.googleapis.com/lupatest/Ubotika-nav/phone-sys.jpg',
  },
  {
    slug: 'ai-receptionist-spanish-bilingual',
    title: 'Bilingual AI Receptionist: Answer Every Caller in English and Spanish',
    description: 'A bilingual AI receptionist answers in English or Spanish, follows the caller\'s language, and books appointments in both. Why it matters in Los Angeles.',
    date: '2026-06-12',
    author: 'UBOTIKA Team',
    readTime: '8 min read',
    tags: ['Bilingual', 'Spanish', 'AI Receptionist', 'Los Angeles'],
    image: 'https://storage.googleapis.com/lupatest/Ubotika-nav/crm.jpg',
  },
  {
    slug: 'how-much-does-an-ai-receptionist-cost',
    dateModified: '2026-09-06',
    title: 'How Much Does an AI Receptionist Cost in 2026?',
    description: 'In 2026, AI receptionists typically cost from a few tens to a few hundred dollars per month. Here\'s what drives the price and how to compare options.',
    date: '2026-06-04',
    author: 'UBOTIKA Team',
    readTime: '7 min read',
    tags: ['Pricing', 'AI Receptionist', 'Small Business', 'ROI'],
    image: 'https://storage.googleapis.com/lupatest/Ubotika-nav/crm.jpg',
  },
  {
    slug: 'ai-receptionist-vs-answering-service',
    title: 'AI Receptionist vs Answering Service: Which Is Better for Small Business?',
    description: 'AI receptionist vs answering service compared on cost, speed, after-hours coverage, booking, and call quality. See which is best for your small business.',
    date: '2026-06-04',
    author: 'UBOTIKA Team',
    readTime: '8 min read',
    tags: ['Comparison', 'AI Receptionist', 'Answering Service', 'Small Business'],
    image: 'https://storage.googleapis.com/lupatest/Ubotika-nav/phone-sys.jpg',
  },
  {
    slug: 'do-ai-phone-agents-actually-work',
    title: 'Do AI Phone Agents Actually Work? An Honest 2026 Breakdown',
    description: 'An honest 2026 look at whether AI phone agents actually work for small businesses: what they do well, where they struggle, and when to add a human.',
    date: '2026-06-04',
    author: 'UBOTIKA Team',
    readTime: '8 min read',
    tags: ['AI Phone Agents', 'Call Handling', 'Small Business', '2026'],
    image: 'https://storage.googleapis.com/lupatest/Ubotika-nav/ai-agents.jpg',
  },
  {
    slug: 'ai-phone-agents-save-la-restaurants-17k-year',
    title: 'How AI Phone Agents Save LA Restaurants $17K/Year',
    description: 'A data-driven breakdown of how AI call handling reduces staffing costs for Los Angeles restaurants, based on real deployment metrics.',
    date: '2026-03-19',
    author: 'UBOTIKA Team',
    readTime: '7 min read',
    tags: ['AI Phone Agents', 'Restaurants', 'Cost Savings', 'Los Angeles'],
    image: 'https://storage.googleapis.com/lupatest/Ubotika-nav/phone-sys.jpg',
  },
  {
    slug: 'crm-integration-small-businesses-complete-guide',
    title: 'CRM Integration for Small Businesses: A Complete Guide',
    description: 'Everything small business owners need to know about connecting AI automation with CRM platforms like Salesforce and HubSpot.',
    date: '2026-03-19',
    author: 'UBOTIKA Team',
    readTime: '9 min read',
    tags: ['CRM', 'Small Business', 'Integration', 'Automation'],
    image: 'https://storage.googleapis.com/lupatest/Ubotika-nav/crm.jpg',
  },
  {
    slug: 'ai-vs-human-call-handling-2026-comparison',
    title: 'AI vs Human Call Handling: 2026 Comparison',
    description: 'Side-by-side comparison of AI and human call agents across cost, speed, accuracy, and customer satisfaction metrics in 2026.',
    date: '2026-03-19',
    author: 'UBOTIKA Team',
    readTime: '8 min read',
    tags: ['AI vs Human', 'Call Handling', 'Comparison', '2026'],
    image: 'https://storage.googleapis.com/lupatest/Ubotika-nav/ai-agents.jpg',
  },
  {
    slug: 'best-ai-receptionist-los-angeles-businesses',
    title: 'Best AI Receptionist for Los Angeles Businesses: What to Look For',
    description: 'A practical buying guide for Los Angeles businesses comparing AI receptionist features, call handling quality, booking workflows, CRM updates, and local support.',
    date: '2026-04-15',
    author: 'UBOTIKA Team',
    readTime: '8 min read',
    tags: ['AI Receptionist', 'Los Angeles', 'Small Business', 'Buying Guide'],
    image: 'https://storage.googleapis.com/lupatest/Ubotika-nav/ai-agents.jpg',
  },
  {
    slug: 'ai-appointment-booking-dental-offices-los-angeles',
    title: 'AI Appointment Booking for Dental Offices in Los Angeles',
    description: 'How Los Angeles dental offices use AI receptionists to answer patient calls, schedule appointments, collect intake details, and reduce front desk overload.',
    date: '2026-04-15',
    author: 'UBOTIKA Team',
    readTime: '7 min read',
    tags: ['Dental AI', 'Appointment Booking', 'Los Angeles', 'AI Receptionist'],
    image: 'https://storage.googleapis.com/lupatest/Ubotika-nav/phone-sys.jpg',
  },
  {
    slug: 'ai-intake-agents-law-firms-los-angeles',
    title: 'AI Intake Agents for Los Angeles Law Firms',
    description: 'How law firms in Los Angeles can use AI intake agents to answer calls faster, qualify new matters, route urgent leads, and document every inquiry.',
    date: '2026-04-15',
    author: 'UBOTIKA Team',
    readTime: '7 min read',
    tags: ['Law Firm AI', 'Client Intake', 'Los Angeles', 'Lead Response'],
    image: 'https://storage.googleapis.com/lupatest/Ubotika-nav/crm.jpg',
  },
];

export function getPostBySlug(slug) {
  return blogPosts.find((p) => p.slug === slug);
}
